import { Map, List, fromJS } from 'immutable'

export function taskTypes(state = List(), action) {
  switch (action.type) {
    case 'TASK_TYPE_FETCH_SUCCESS':
      let items = action.items || []
      return fromJS(items).sort((a, b) => {
        let aValue = a.getIn(['data', 'order'], 999)
        let bValue = b.getIn(['data', 'order'], 999)
        return aValue > bValue ? 1 : -1
      })
    default:
      return state
  }
}

export function taskTypesLoading(state = true, action) {
  switch (action.type) {
    case 'TASK_TYPE_FETCH_SUCCESS':
    case 'TASK_TYPE_FETCH_ERROR':
      return false
    default:
      return state
  }
}

export function taskTypesError(state = false, action) {
  switch (action.type) {
    case 'TASK_TYPE_FETCH_ERROR':
      return action.message
    default:
      return state
  }
}
